var env = require("../utils/env");
var apiDomain = env.domain.api;
var request = require('superagent');

var exports = module.exports = {};

exports.userCourses = [];
exports.conceptsTreeMapping = {};
exports.conceptsMapping = {};
exports.conceptLeafMapping = {};

var buildConceptMap = function(conceptTree) {
  exports.conceptsMapping[conceptTree._id] = conceptTree;
  for (var i = 0; i < conceptTree.children.length; i++) {
    buildConceptMap(conceptTree.children[i]);
  }
}

exports.retrieveUserCourses = function(callback) {
  if (exports.userCourses && exports.userCourses.length > 0) return callback(null, exports.userCourses);
  request.get(apiDomain + '/v1/courses')
  .then(function(response) {
    exports.userCourses = response.body;
    return callback(null, response.body);
  }, function(err) {
    return callback(err.response.body);
  })
}

exports.retrieveAllConceptsMap = function(callback) {
  exports.retrieveUserCourses(function(err, response) {
    if (err) return callback(err);
     var courseCount = response.length;
     for (var i = 0; i < response.length; i++) {
       var conceptId = response[i].metadata.concepts[0];
       exports.retrieveConceptTree(conceptId, function(err2, response2) {
         if (!err2 && response2) {
           buildConceptMap(response2);
           courseCount--;
           if (courseCount <= 0) return callback(null, exports.conceptsMapping);
         }
       })
     }
  })
}

exports.retrieveAllConceptsLeafMap = function(callback) {
  callback = callback || function(){};
  exports.retrieveUserCourses(function(err, response) {
    if (err) return callback(err);
    var courseCount = response.length;
    for (var i = 0; i < response.length; i++) {
      var conceptId = response[i].metadata.concepts[0];
      exports.retrieveConceptLeafMapping(conceptId, function(err2, response2) {
        courseCount--;
        if (courseCount <= 0) return callback(null, exports.conceptLeafMapping)
      })
    }
  })
}
exports.retrieveAllQuestionOfConcept = function(options, callback) {
  callback = callback || function(){};
  options = options || {};
  request.get(apiDomain + "/v1/kquestions")
  .query({
      sort: options.sort || '-dateCreated',
      limit: options.limit || 12,
      conditions: JSON.stringify(options.conditions)
  }).then(function(response){
      return callback(null, response.body);
  }, function(err){
      return callback(err.response.body);
  })
}

exports.retrieveConceptLeafMapping = function(conceptId, callback) {
  callback = callback || function(){};
  if (exports.conceptLeafMapping[conceptId]) return callback(null, exports.conceptLeafMapping[conceptId]);
  request.get(apiDomain + "/v1/concepts")
  .query({
    leaf: true,
    max_level: 4,
    root: conceptId
  }).then(function(response) {
    for (var i in response.body) {
      exports.conceptLeafMapping[response.body[i]._id] = response.body[i];
    }
    return callback(null, exports.conceptLeafMapping);
  }, function(err) {
    return callback(err.response.body);
  })
}

exports.retrieveConceptTree = function(conceptId, callback) {
  callback = callback || function(){};
  if (exports.conceptsTreeMapping[conceptId]) return callback(null, exports.conceptsTreeMapping[conceptId]);
  request.get(apiDomain + '/v1/concepts')
  .query({
    tree: true,
    max_level: 4,
    root: conceptId
  }).then(function(response) {
    exports.conceptsTreeMapping[conceptId] = response.body;
    return callback(null, response.body);
  }, function(err) {
    return callback(err.response.body);
  })
}

exports.buildConceptToCollectionData = function(collectionData, conceptsMap) {
  if (collectionData.questions && collectionData.questions.length > 0) {
    for (var ii in collectionData.questions) {
      var kquestion = collectionData.questions[ii].kquestion;
      if (kquestion.concepts) {
        for (var i = 0; i < kquestion.concepts.length; i++) {
          if (conceptsMap[kquestion.concepts[i]])
            kquestion.conceptLeafInfo = conceptsMap[kquestion.concepts[i]];
        }
      }
    }
  }
  return collectionData;
}



/** WEBPACK FOOTER **
 ** ./src/resources/concept.js
 **/